import React, { Dispatch, RefObject, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import styles from "./new-chat-button.module.scss";
import { NewChatButtonState } from "./new-chat-button.types";
import NewChatSelect from "./new-chat-select/new-chat-select.component";

import NewChatIcon from "~/view/assets/new-chat-icon";
import { setNewChatModalIsOpen, setNewChatServiceModalIsOpen } from "~/app/modals/modals.actions";

const NewChatButtonComponent: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();
  const ref: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);

  const [newChatButtonState, setNewChatButtonState]: [
    NewChatButtonState,
    React.Dispatch<React.SetStateAction<NewChatButtonState>>
  ] = useState<NewChatButtonState>({ isNewChatSelectOpen: false });

  const handleSetNewChatModalOpen: (isOpen: boolean) => void = (isOpen: boolean): void => {
    dispatch(setNewChatModalIsOpen(isOpen));
  };

  const handleSetNewChatServiceModalOpen: (isOpen: boolean) => void = (isOpen: boolean): void => {
    dispatch(setNewChatServiceModalIsOpen(isOpen));
  };

  const handleOpenNewChatSelect: () => void = () => {
    setNewChatButtonState({
      isNewChatSelectOpen: newChatButtonState.isNewChatSelectOpen ? false : true
    });
  };

  const handleMouseEvent: (e: MouseEvent) => void = (e: MouseEvent): void => {
    if (newChatButtonState.isNewChatSelectOpen && ref.current && !ref.current.contains(e.target as HTMLDivElement)) {
      handleOpenNewChatSelect();
    }
  };

  useEffect(() => {
    document.addEventListener("click", (e): void => handleMouseEvent(e));
    return (): void => {
      document.removeEventListener("click", (e): void => handleMouseEvent(e));
    };
  }, [newChatButtonState]);

  return (
    <div className={styles.NewChatButtonComponent} ref={ref}>
      {newChatButtonState.isNewChatSelectOpen && (
        <NewChatSelect
          setNewChatModalIsOpen={handleSetNewChatModalOpen}
          setNewChatServiceModalIsOpen={handleSetNewChatServiceModalOpen}
          setNewChatButtonState={handleOpenNewChatSelect}
        />
      )}
      <button onClick={(): void => handleOpenNewChatSelect()}>
        <NewChatIcon />
      </button>
    </div>
  );
};

export default NewChatButtonComponent;
